export enum DocumentViewModeEnum {
    Annotations = 'Annotations',
    Drawing = 'Drawing',
    TextItems = 'TextItems',
    ClickFill = 'ClickFill',
    Viewing = 'Viewing',
}
